const ISSUE_NOTIFICATION_CONFIGURATION_API_PATH =
  '/issues-tracking/v1/issues/config/notifications';
const ISSUE_USERS_API_PATH = '/issues-tracking/v1/issues/users';

const MY_NOTIFICATIONS_API_PATH = '/sxcl/v1/notifications';
const MY_NOTIFICATIONS_STREAM_API_PATH = `${MY_NOTIFICATIONS_API_PATH}/stream`;
const MY_NOTIFICATIONS_UNREAD_COUNT_API_PATH = `${MY_NOTIFICATIONS_API_PATH}/unread-count`;
const MY_NOTIFICATIONS_READ_ALL_API_PATH = `${MY_NOTIFICATIONS_API_PATH}/read-all`;
const MY_NOTIFICATION_PREFERENCES_API_PATH = `${MY_NOTIFICATIONS_API_PATH}/preferences`;

const buildMarkNotificationReadApiPath = (
  notificationId,
  { includeGroup } = {},
) =>
  `${MY_NOTIFICATIONS_API_PATH}/${notificationId}/read${
    includeGroup ? '?includeGroup=true' : ''
  }`;

const buildNotificationGroupApiPath = notificationId =>
  `${MY_NOTIFICATIONS_API_PATH}/${notificationId}/group`;

const buildUserNotificationPreferencesApiPath = userId =>
  `/sxcl/v1/users/${userId}/notification-preferences`;

export {
  ISSUE_NOTIFICATION_CONFIGURATION_API_PATH,
  ISSUE_USERS_API_PATH,
  MY_NOTIFICATIONS_API_PATH,
  MY_NOTIFICATIONS_STREAM_API_PATH,
  MY_NOTIFICATIONS_UNREAD_COUNT_API_PATH,
  MY_NOTIFICATIONS_READ_ALL_API_PATH,
  MY_NOTIFICATION_PREFERENCES_API_PATH,
  buildMarkNotificationReadApiPath,
  buildNotificationGroupApiPath,
  buildUserNotificationPreferencesApiPath,
};
